import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TransactionsPage } from './transactions';

@NgModule({
  declarations: [
    TransactionsPage,
  ],
  imports: [
    IonicPageModule.forChild(TransactionsPage),
  ],
})
export class TransactionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/transactions/transactions.module.ts